<div class="sub-nav-for-collapsed">
    <shared-drop-down class="sub-nav-for-collapsed__dropdown" [options]="pages" position="br" [selected]="selectedPage"
        (onSelected)="handleDropDownSelected($event)">
        <button class="sub-nav-for-collapsed__btn" [disabled]="totalCategories === 0">
            <shared-badge [type]="badgeType" size="sm" class="sub-nav-for-collapsed__badge">{{totalCategories}}
            </shared-badge>
            <label class="sub-nav-for-collapsed__label">Categories</label>
            <shared-icon icon="burger-menu" class="sub-nav-for-collapsed__icon"></shared-icon>
        </button>
    </shared-drop-down>
</div>